import { colors } from '../../../../../colorVars';

export const groupNumberMap = [
  { value: 0, label: '0', color: colors.grey },
  { value: 1, label: '1', color: colors.blue },
  { value: 2, label: '2', color: colors.green },
  { value: 3, label: '3', color: colors.red },
  { value: 4, label: '4', color: colors.orange },
  { value: 5, label: '5', color: colors.purple },
  { value: 6, label: '6', color: colors.yellow },
];
